<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">
								Withdraw Change Request
							</div>
							<!--页头-->
							<div class="page_main">
								<!-- <div class="btn_el">
									<div class="tips">
										Please enter an explanation for withdrawing this request from the document control process.
									</div>
								</div> -->
								<el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="request-form">
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Request ID">
												<el-input v-model="form.request_id" readonly class="gray-input">
													<template slot="prepend" v-if="false"></template>
												</el-input>
											</el-form-item>
											<el-form-item label="Initiator">
												<el-input v-model="form.username" readonly class="gray-input"></el-input>
											</el-form-item>
										</div>
				
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Change Request Creation Date">
												<el-input v-model="form.dateline" readonly class="gray-input"></el-input>
											</el-form-item>
				
											<el-form-item v-if="form.status_name" label="Status">
												<el-input v-model="form.status_name" readonly class="gray-input"></el-input>
											</el-form-item>
										</div>
									</div>
				
									<div class="form-col">
										<el-form-item label="Overall Description of Change Request">
											<el-input 
												v-model="form.overall_description" 
												type="textarea" 
												:rows="5" 
												readonly 
												class="gray-input" />
										</el-form-item>
				
										<el-form-item label="Reason / Justification for Change Request">
											<el-input 
												v-model="form.reason" 
												type="textarea" 
												:rows="5" 
												readonly 
												class="gray-input" />
										</el-form-item>
									</div>
				
									<div class="divider" />
				
									<div class="btn_el">
										<div class="tips">
											Please enter an explanation for withdrawing this request from the document control process and confirm with your signature.
										</div>
									</div>
				
									<el-form-item prop="remark">
										<template slot="label">
											<span>
												Comment
											</span>
										</template>
										<el-input 
											v-model="form.remark" 
											type="textarea" 
											:rows="5" 
											placeholder="Please enter"
											resize="none">
										</el-input>
									</el-form-item>
				
									<el-form-item prop="signature">
										<template slot="label">
											<span>
												Signature Key
											</span>
										</template>
										<el-input 
											v-model="form.signature" 
											type="password" 
											show-password 
											placeholder="Please enter your login password"
										/>
									</el-form-item>
				
								</el-form>
				
								<div class="footer-actions">
									<el-button type="primary" @click="handleSave">
										Confirm
									</el-button>
				
									<el-button type="primary" @click="handleCancel">
										Cancel
									</el-button>
								</div>
				
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail,
	resourcesApplyWithdraw
} from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			keyword: "",
			form: {
				request_id: '',
				username: '',
				dateline: '',
				status_name: '',
				overall_description: '',
				reason: '',
				remark: '',
				signature: ''
			},
			rules: {
				remark: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				signature: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				]
			}
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		//请求审批详情
		resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
			if(res.code == 200) {
				that.form.request_id = res.data.request_id;
				that.form.username = res.data.username;
				that.form.dateline = res.data.dateline;
				that.form.status_name = res.data.status_name;
				that.form.overall_description = res.data.overall_description;
				that.form.reason = res.data.reason;
				that.isLoading = false;
			}
		});
	},
	watch: {
		//
	},
	methods: {
		//保存
		handleSave() {
			let that = this;
			that.$refs.formRef.validate((valid) => {
				if(!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				resourcesApplyWithdraw({
					id: that.$route.query.oid,
					remark: that.form.remark,
					signature: md5(that.form.signature+'AiisoQms2026')
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.puah({ path: '/task-list' });
						}, 800);
					}
				});
			});
		},
		//取消
		handleCancel() {
			this.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input ::v-deep .el-input__inner {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.gray-input ::v-deep .el-textarea__inner{
	background: #e9ecef;
	border: 1px solid #cfd5db;
	color: #2f343b;
	border-radius: 8px;
	font-size: 14px;
}

.gray-input ::v-deep .el-input__inner[readonly], .gray-input ::v-deep .el-textarea__inner[readonly] {
  cursor: default;
}

.divider {
  height: 1px;
  background: #dcdfe6;
  margin: 24px 0;
}

.required-star {
  color: #f56c6c;
  margin-left: 2px;
}

.footer-actions {
  margin-top: 26px;
  display: flex;
  justify-content: center;
  gap: 14px;
}
</style>

